import { SYNODIC_MONTH_DAYS } from "../simulation/constants";
import { useSimulation } from "../simulation/SimulationProvider";

export function Timeline() {
  const { setDay, state } = useSimulation();

  return (
    <section className="timeline" aria-label="Lunar cycle timeline">
      <label htmlFor="lunar-day">Lunar cycle day</label>
      <input
        id="lunar-day"
        aria-label="Lunar cycle day"
        type="range"
        min={0}
        max={SYNODIC_MONTH_DAYS}
        step={0.01}
        value={state.day}
        onChange={(event) => setDay(Number(event.currentTarget.value))}
      />
      <span className="timeline-value">Day {state.day.toFixed(1)}</span>
    </section>
  );
}
